import styled from 'styled-components';

/**
 * @since 8.28.0
 */
var ListboxOptionMedia = /*#__PURE__*/styled.div.withConfig({
  displayName: "ListboxOptionMedia",
  componentId: "c11n-8-111-1__sc-h1w6cf-0"
})([""]);
ListboxOptionMedia.displayName = 'ListboxOptionMedia';

/** @component */
export { ListboxOptionMedia };